// extracted by mini-css-extract-plugin
var _1 = "ra-activity-simple-action";
var _2 = "ra-activity-simple";
var _3 = "ra-activity-simple-label";
var _4 = "ra-activity-simple-touch";
export { _1 as "activitySimpleActionCls", _2 as "activitySimpleCls", _3 as "activitySimpleLabelCls", _4 as "activitySimpleTouchCls" }
